var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "GmapMap",
        {
          staticClass: "o-maps",
          attrs: {
            center: _vm.center,
            zoom: 10,
            options: _vm.options,
            "map-type-id": "roadmap"
          },
          on: {
            click: function($event) {
              _vm.infoWinOpen = false
            }
          }
        },
        [
          _c(
            "GmapCluster",
            {
              attrs: {
                "grid-size": 30,
                styles: _vm.clusterStyles,
                "zoom-on-click": true
              }
            },
            [
              _c("GmapInfoWindow", {
                attrs: {
                  options: _vm.infoOptions,
                  position: _vm.infoWindowPos,
                  opened: _vm.infoWinOpen
                },
                on: {
                  closeclick: function($event) {
                    _vm.infoWinOpen = false
                  }
                }
              }),
              _vm._v(" "),
              _vm._l(_vm.mapMarkers, function(marker, index) {
                return _c("GmapMarker", {
                  key: index,
                  attrs: {
                    position: marker.position,
                    clickable: true,
                    icon: marker.icon
                  },
                  on: {
                    click: function($event) {
                      return _vm.toggleInfoWindow(marker, index)
                    }
                  }
                })
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }